import React, { Component } from "react";
import { Accessor, ColorX, GFunc, IconX, LocaleX, ResponsiveX } from "IZOX/STATIC";
import { ActivityIndicator, HStack, Spacer, VStack, XButton, XDiv, XIconButton, XScroll, XText } from "IZOX/_X";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { observer } from "mobx-react";
import Breadcrumb from "shared/Breadcrumb";
import { SysConfig } from "__SYSDefault/Config";
import APIExpress from "__SYSDefault/APIs/APIExpress";
import HContactInfo from "shared/HContactInfo";
import _ from "lodash";
import Styles from "__SYSDefault/Styles";
import HTMLReactParser from "html-react-parser";
import FooterM from "shared/FooterM";
import HContactInfoM from "shared/HContactInfoM";

/**
 * @augments {Component<Props, State>}
 */
class PTandC extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates(() => {
      this._GetInfo();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PTandC.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    if(this.interval) clearInterval(this.interval);
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _setTimeout = (func, delay) => {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(func, delay);
  }

  _setInterval = (func, interval) => {
    if(this.interval) clearInterval(this.interval);
    this.interval = setInterval(func, interval);
  }

  _GetInfo = async () => {
    let info = await APIExpress.WebSettings.GetInfo();
    this.setState({
      info: info
    });
  }

  _Popup = (o) => {
    let {title, content} = o;
    GFunc.Backdrop(() => {
      return (
        <VStack bgColor={ColorX.CSS("pureWhite")}
          width={705} maxWidth={"95%"} maxHeight={window.innerHeight * 0.9}>
          <HStack pH={16} shadow>
            <XText fontSize={16} bold fontFamily="Noto Sans SC">
              {LocaleX.Parse(title)}
            </XText>
            <Spacer/>
            <XIconButton onPress={() => GFunc.CloseBackdrop()}>
              {IconX.Get("ant", "close", 20, ColorX.CSS("Stone"))}
            </XIconButton>
          </HStack>
          <XScroll p={16} fullWidth style={{maxHeight: window.innerHeight * 0.7}}>
            <XText textAlign="[" fullWidth>
              {HTMLReactParser(LocaleX.Parse(content))}
            </XText>
          </XScroll>
        </VStack>
      );
    }, {}, false, false);
  }

  renderBreadcrumb(){
    return (
      <HStack HAlign="[">
        <Breadcrumb 
          steps={[
            {
              caption: {
                EN: "Home",
                TC: "主頁"
              },
              target: "Home"
            }
          ]}
          last={{
            EN: "Terms and Conditions",
            TC: "條款及細則"
          }}/>
      </HStack>
    );
  }

  renderCard(o, i){
    let {title} = o;
    return (
      <VStack key={i} bgColor={ColorX.CSS("NotQuiteWhite")} 
        pV={16} spacing={9} width={"49%"} mB={16} p={8}>
        <XText fontSize={16} color={ColorX.CSS("Leaf")} bold textAlign="|" style={{height: 48}}>
          {LocaleX.Parse(title)}
        </XText>
        <XButton {...Styles.QFBtn} width={200} padding={0} pV={8} pH={24}
          onPress={() => this._Popup(o)}>
          <HStack>
            <XText bold fontSize={16}>
              {LocaleX.Parse({
                EN: "Read More",
                TC: "閱讀更多"
              })}
            </XText>
          </HStack>
        </XButton>
      </VStack>
    );
  }

  renderTCGrid(){
    let {info} = this.state;
    let {tandc} = info ?? {};
    let {page} = tandc ?? {};

    return (
      <XDiv display="flex" flexWrap="wrap" spacing={16} justifyContent="space-between">
        {_.map(page, (o, i) => {
          return this.renderCard(o, i);
        })}
      </XDiv>
    );
  }

  renderMain(){
    let {info} = this.state;
    return (
      <VStack spacing={16} width={848} HAlign="[">
        <XText fontSize={32} color={ColorX.CSS("Stone")} bold>
          {LocaleX.Parse({
            EN: "Terms and Conditions",
            TC: "條款及細則"
          })}
        </XText>
        <XDiv>
          {this.renderTCGrid()}
        </XDiv>
        <HContactInfo info={info}/>
      </VStack>
    );
  }

  renderNormal(){
    return (
      <VStack fullWidth>
        <VStack width={SysConfig.ContentWidth} pH={80}>
          {this.renderBreadcrumb()}
          {this.renderMain()}
        </VStack>
      </VStack>
    );
  }

  renderBreadcrumbM(){
    return (
      <HStack HAlign="[" pH={26}>
        <Breadcrumb 
          steps={[
            {
              caption: {
                EN: "Home",
                TC: "主頁"
              },
              target: "Home"
            }
          ]}
          last={{
            EN: "Terms and Conditions",
            TC: "條款及細則"
          }}/>
      </HStack>
    );
  }

  renderCardM(o, i){
    let {title} = o;
    return (
      <VStack key={i} bgColor={ColorX.CSS("NotQuiteWhite")} 
        pV={16} spacing={9} fullWidth mB={16} p={8}>
        <XText fontSize={16} color={ColorX.CSS("Leaf")} bold textAlign="|" style={{height: 48}}>
          {LocaleX.Parse(title)}
        </XText>
        <XButton {...Styles.QFBtn} width={200} padding={0} pV={8} pH={24}
          onPress={() => this._Popup(o)}>
          <HStack>
            <XText bold fontSize={16}>
              {LocaleX.Parse({
                EN: "Read More",
                TC: "閱讀更多"
              })}
            </XText>
          </HStack>
        </XButton>
      </VStack>
    );
  }

  renderTCGridM(){
    let {info} = this.state;
    let {tandc} = info ?? {};
    let {page} = tandc ?? {};

    return (
      <VStack fullWidth spacing={16}>
        {_.map(page, (o, i) => {
          return this.renderCardM(o, i);
        })}
      </VStack>
    );
  }

  renderMainM(){
    let {info} = this.state;
    return (
      <VStack spacing={26} fullWidth HAlign="[" pH={26}>
        <XText fontSize={32} color={ColorX.CSS("Stone")} bold>
          {LocaleX.Parse({
            EN: "Terms and Conditions",
            TC: "條款及細則"
          })}
        </XText>
        {this.renderTCGridM()}
        <HContactInfoM info={info}/>
      </VStack>
    );
  }

  renderMobile(){
    return (
      <VStack fullWidth>
        {this.renderBreadcrumbM()}
        {this.renderMainM()}
        <FooterM/>
      </VStack>
    );
  }

  render(){
    let {info} = this.state;
    if(!info){
      return (
        <VStack fullWidth fullHeight VAlign="-" HAlign="|">
          <ActivityIndicator loading size={Math.min(100, window.innerWidth * 0.5)} thickness={10}/>
        </VStack>
      );
    }
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal()
    });
  }

}

export default observer(PTandC);
